import axios from "axios";

export default axios.create({

    baseURL: "https://api.rudratmx.com/public/api",

    headers: {
        "Content-Type": "application/json"
    }
});